export class Event {
	private _didStopImmediatePropagation = false

	didStopImmediatePropagation(): boolean {
		return this._didStopImmediatePropagation
	}

	stopImmediatePropagation(): void {
		this._didStopImmediatePropagation = true
	}
}
